import React, { ComponentProps, ReactNode } from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'
import { combinedAnalytics } from 'src/utils/common'

type Props = {
  active: boolean
  content: ReactNode
  icon: ReactNode
  id: string
  onSelect: (id: string) => void
  title: ReactNode
  type?: 'featured'
}

export const Tab = ({ active, id, icon, title, onSelect, type }: Props) => {
  const handleSelect = () => {
    combinedAnalytics('Button', 'Button', 'Coin', title)

    onSelect(id)
  }

  return (
    <div
      className={clsx(styles.tab, {
        [styles.active]: active,
        [styles.featured]: type === 'featured',
      })}
      onClick={handleSelect}
    >
      {icon && <span className={styles.icon}>{icon}</span>}
      {title}
    </div>
  )
}

export default Tab
